<template>
  <router-view />
  <el-drawer
    v-model="drawerVisible"
    direction="btt"
    :show-close="false"
    :with-header="false"
    style="height: auto"
  >
    <AppSettingsPanel v-if="drawerVisible" />
  </el-drawer>
  <el-dialog
    v-model="dialogVisible"
    align-center
    modal-class="contact-us-modal"
    :show-close="false"
  >
    <div class="modal-content">
      <div class="title">{{ $t('home.modal_contact_us.title') }}</div>
      <ContactBox :contactList="contactUsList" />
    </div>
  </el-dialog>
  <el-dialog
    v-model="captchaDialogVisible"
    align-center
    modal-class="captcha-modal"
    :show-close="false"
    @close="onCaptchaClose"
  >
    <div class="captcha-container">
      <h3>{{ $t('verifyHuman') }}</h3>
      <div id="h-captcha" :data-size="common.isMobileSize ? 'compact' : ''"></div>
    </div>
  </el-dialog>
  <TGModal v-if="showTGModal" @close="closeTGModal" :url="tgUrl" />
</template>

<script setup>
import tp from "tp-js-sdk";
import { includes } from "lodash";
import 'element-plus/dist/index.css';
import { ElDialog, ElDrawer } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { onMounted, ref, computed, watch } from 'vue';
import { useCommonStore } from './stores/common';
const common = useCommonStore();

import emitter from './utils/bus';
import { setMode, createQueryObj, changeURLArg } from './utils';
import AppSettingsPanel from './components/tools/AppSettingsPanel.vue';
import ContactBox from './components/tools/ContactBox.vue';
import TGModal from './components/tools/TGModal.vue';

const { t } = useI18n();

const drawerVisible = ref(false);
const dialogVisible = ref(false);
const captchaDialogVisible = ref(false);
const showTGModal = ref(false);
const tgUrl = ref('');

onMounted(() => {
  emitter.on('tg-modal', res => {
    // console.log('tg-modal', res);
    const { show, url} = res
    tgUrl.value = url
    dialogVisible.value = false
    showTGModal.value = show
  })
  emitter.on('show-drawer', res => {
    // console.log('show-drawer', res);
    drawerVisible.value = true
  })
  emitter.on('captcha-dialog', (flag) => {
    captchaDialogVisible.value = flag
  })
})

const darkModeImg = computed(() => {
  return common.isDark ? '-dark' : '';
});

const contactUsList = computed(() => {
  return [
    // {
    //   // url: 'https://twitter.com/TransitFinance',
    //   class: `follow-item-1${darkModeImg.value}`,
    //   url: 'https://twitter.com/TransitFinance',
    //   icon: require(`./assets/footer/1${darkModeImg.value}.png`),
    //   title: t('home.modal_contact_us.X'),
    //   urlIcon: require(`./assets/dialog/share.png`),
    // },
    {
      class: `follow-item-2${darkModeImg.value}`,
      url: 'https://t.me/Transit_Finance',
      icon: require(`./assets/dialog/telegram${darkModeImg.value}.png`),
      title: t('home.modal_contact_us.telegram'),
      urlIcon: require(`./assets/dialog/share.png`),
      istTelegram: true
    },
    {
      class: `follow-item-3${darkModeImg.value}`,
      url: 'service@transit.finance',
      icon: require(`./assets/dialog/email${darkModeImg.value}.png`),
      title: t('home.modal_contact_us.serviceEmail'),
      copyIcon: require(`./assets/dialog/copy-hover.png`),
    },
    {
      class: `follow-item-3${darkModeImg.value}`,
      url: 'https://opserver.zendesk.com/hc/en-us/requests/new',
      icon: require(`./assets/home/contact${darkModeImg.value}.png`),
      title: t('home.modal_contact_us.text_2'),
      urlIcon: require(`./assets/dialog/share.png`),
    },
  ];
})

watch(
  () => drawerVisible.value,
  (n,o) => {
    if (n) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
})

const closeTGModal = () => {
  showTGModal.value = false
}

let queryObj = createQueryObj();
common.queryObj = queryObj

// 允许的三种模式，如果都不符合则按照系统的模式
const availableTheme = ['light', 'dark', 'auto'];
let theme = ''
let queryTheme = includes(availableTheme, queryObj['theme']) ? queryObj['theme'] : 'auto';
if (queryObj['theme']) {
  theme = queryTheme
} else {
  theme = localStorage.getItem('theme');
}
common.theme = theme || 'light';
// changeURLArg({ theme: '' })
// let mode = false;

// let theme = localStorage.getItem('theme');
let mode = false;

// 如果已经设置过暗黑模式
const isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)'); // 是深色
// console.log('isDarkTheme', isDarkTheme);
if (theme) {
  if (theme === 'auto' && isDarkTheme) {
    if (isDarkTheme.matches) {
      // 主题设置为深色。
      mode = true;
    } else {
      // 主题设置为浅色。
      mode = false;
    }
  } else if (theme == 'dark') {
    mode = true;
  } else {
    mode = false;
  }
  setMode(mode)
  common.changeMode(mode)
  // store.commit('setDarkMode', mode)
} else {
  if (navigator.userAgent.indexOf('TokenPocket') === -1) {
    if (isDarkTheme.matches) {
      // 主题设置为深色。
      mode = true;
    } else {
      // 主题设置为浅色。
      mode = false;
    }
    setMode(mode)
    common.changeMode(mode)
    // store.commit('setDarkMode', mode)
  } else {
    tp.isDarkMode().then(res => {
      // console.log('tp', res);
      if (res && res.data) {
        mode = true
      } else {
        mode = false
      }
      setMode(mode)
      common.changeMode(mode)
      // store.commit('setDarkMode', mode)
    })
  }
}

onMounted(() => {
  // document.title = t('feedbackTitle');
  systemChange();
  common.isMobileSize = document.documentElement.clientWidth <= 767;
  window.onresize = () => {
    common.isMobileSize = document.documentElement.clientWidth <= 767;
  };
  emitter.on('contact-us', (res) => {
    // console.log('res', res);
    if (res && res.show) {
      dialogVisible.value = true;
    }
  });
});

const onCaptchaClose = () => {
  console.log('captcha close');
  emitter.emit('start-step');
}

const systemChange = () => {
  const isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)');
  if (isDarkTheme) {
    isDarkTheme.onchange = (e) => {
      // console.log('systemChange', isDarkTheme);
      const theme = localStorage.getItem('theme');
      let mode = false;
      if (theme && theme === 'auto') {
        console.log('auto');
        if (e.matches) {
          console.log('设置深色主题');
          mode = true;
        } else {
          console.log('设置浅色主题');
          mode = false;
        }
        common.changeMode(mode);
        setMode(mode);
      }
    };
  }
};
</script>

<style lang="scss">
.el-drawer {
  border-radius: 24px 24px 0 0;
  background: var(--wrap-bg);
  height: auto !important;
  .el-drawer__body {
    padding: 16px 16px 61px;
  }
}
.el-overlay {
  .el-dialog {
    padding: 24px;
    background: var(--wrap-bg);
    border: 1px solid var(--mobile-app-setting-border);
    border-radius: 20px;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.2);
    width: 378px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
    .modal-content {
      .title {
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: var(--color-5);
        line-height: 28px;
      }
      .desc {
        margin-top: 16px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #e55036;
        line-height: 21px;
      }
      .contact-transit-buy {
        margin-top: 0.4rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .button {
          margin-top: 0.16rem;
          width: 0.64rem;
          height: 0.64rem;
          border: 0.01rem solid var(--border-1);
          border-radius: 0.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .contact-img {
            width: 0.32rem;
            height: 0.3rem;
            background: url('./assets/home/contact.png') no-repeat 100% / contain;
            &.isDark {
              background: url('./assets/home/contact-dark.png') no-repeat 100% / contain;
            }
          }
        }
        .button:hover {
          background: #2980fe;
          border: 1px solid #2980fe;
          .contact-img {
            width: 0.32rem;
            height: 0.3rem;
            background: url('./assets/home/contact-dark.png') no-repeat 100% / contain;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .el-overlay {
    .el-dialog {
      width: auto;
      max-width: 88%;
    }
  }
}
</style>
